export default {
  value: null,
  meta: {
    alt: null,
    redirect_link: null,
  },
}
